<template>
  <div v-if="discountPercent" class="[text-box:trim-both_cap_alphabetic] [font-size:min(7cqw,24px)] leading-none rounded-full size-[3.5em] whitespace-nowrap overflow-hidden flex items-center justify-center font-display font-medium bg-red-700 text-white pointer-events-none">
    -{{ discountPercent }} %
  </div>
</template>

<script setup lang="ts">
defineProps({
  discountPercent: {
    type: Number,
    default: 0
  }
})
</script>
